import React from 'react'
import PackageCard from '../PackageCard';
import { SimpleGrid } from '@mantine/core';

const ExteriorDetail = () => {


  const basicExterior = [
    'Two bucket hand wash', 
    'Tires, wheels, and wheel wells cleaned and dressed', 
    'Bug and tar removal', 
    'Streak-free exterior glass cleaning', 
    // 'CarFax record update'
  ]

  const deluxeExterior = [
    'Two bucket hand wash', 
    'Tires, wheels, and wheel wells cleaned and dressed', 
    'Door and trunk jambs cleaned', 
    'Bug and tar removal', 
    'Decontaminate remaining impurities with clay-bar',
    // 'Paint Enhancement with Dual Action Polisher',
    'Paint is coated with high-quality wax', 
    'Streak-free exterior glass cleaning',
    // 'CarFax record update'
  ]

  const supremeExterior = [
    'Two bucket hand wash', 
    'Tires, wheels, and wheel wells cleaned and dressed', 
    'Door and trunk jambs cleaned', 
    'Bug and tar removal', 
    'Decontaminate remaining impurities with clay-bar',
    'Paint Enhancement with Dual Action Polisher',
    'Paint is coated with high-quality sealant',
    'Streak-free exterior glass cleaning',
    'Engine bay detailed and dressed',
    'Undercarriage wash',
    // 'CarFax record update'
  ]

  return (
    <div>
      <SimpleGrid
      cols={3}
      spacing="lg"
      breakpoints={[
        { maxWidth: '62rem', cols: 3, spacing: 'md' },
        { maxWidth: '48rem', cols: 1, spacing: 'sm' },
        { maxWidth: '36rem', cols: 1, spacing: 'sm' },
      ]}
      >
        <PackageCard
        packageTitle="Bronze Exterior Detail"
        packageDuration=""
        included={basicExterior}
        price="$75"
        bookingLink="https://app.urable.com/virtual-shop/nm5qG9H2g5ahH4Xkm9TN"
        />
        <PackageCard
        packageTitle="Silver Exterior Detail"
        packageDuration=""
        included={deluxeExterior}
        price="$200"
        bookingLink="https://app.urable.com/virtual-shop/nm5qG9H2g5ahH4Xkm9TN"
        />
        <PackageCard
        packageTitle="Gold Exterior Detail"
        packageDuration=""
        included={supremeExterior}
        price="$250"
        bookingLink="https://app.urable.com/virtual-shop/nm5qG9H2g5ahH4Xkm9TN"
        />

      </SimpleGrid>
    </div>
  )
}

export default ExteriorDetail;